import React, { useState } from 'react';
import styles from './BigWork.module.css';
import imgs from '../../../assets/workInfo/imgs.js';
import Modal from '../../../components/Modal/Modal';

const BigWork = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (image) => {
    setModalOpen(true);
    setSelectedImage(image);
    document.body.classList.add(styles['modal-open']);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setModalOpen(false);
    document.body.classList.remove(styles['modal-open']);
  };

  return (
    <div className={styles.main}>
      <div className={styles.imgContainer}>
        {imgs?.map((item, idx) => (
          <div
            className={styles.imgBox}
            key={idx}
            onClick={() => openModal(item)}
          >
            <img
              className={styles.img}
              src={item.link}
              alt={item.alter}
              border="0"
            />
          </div>
        ))}
      </div>

      <Modal
        isOpen={modalOpen}
        onClose={closeModal}
        selectedImage={selectedImage}
      />
    </div>
  );
};

export default BigWork;
